<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> TIPO DE LANÇAMENTO DA FATURA</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="type_release.id"
          >{{ type_release.id }} -
          {{ type_release.description.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-text-field
                v-model="type_release.description"
                class="text-field-uppercase"
                label="Descrição"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-select
                :items="operations"
                v-model="type_release.operation"
                label="Tipo de Operação"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    loading: false,
    error: "",
    type_release: {
      id: "",
      description: "",
      operation: "desconto",
    },
    operations: [
      { value: "desconto", text: "(-) DESCONTO" },
      { value: "acrescimo", text: "(+) ACRÉSCIMO" },
    ],
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getFinancialRelease(this.$route.params.id);
      }
    },
    async getFinancialRelease(id) {
      this.loading = true;
      try {
        let response = await fetch(`${URL}financial-release-type/${id}`);
        this.type_release = await response.json();
      } catch (error) {
        this.type_release = {};
        console.log(error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "FinancialReleaseType" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.type_release.description =
          this.type_release.description.toUpperCase();
        let data = new URLSearchParams(this.type_release);
        if (this.type_release.id === "") {
          this.post(data);
        } else {
          this.update(this.type_release.id, data);
        }
      }
    },
    async post(data) {
      this.loading = true;
      try {
        let res = await fetch(`${URL}financial-release-type`, {
          method: "POST",
          body: data,
        });
        if (res) {
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        let res = await fetch(`${URL}financial-release-type/${id}`, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          method: "PUT",
          body: data,
        });
        if (res) {
          this.goToBackList();
        }
      } catch (error) {
        this.error = error.message;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
